import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "px-4" }

import { computed } from 'vue'

type NotificationStatus = 'error' | 'warning' | 'success'

interface Props {
  /** The status type of the notification */
  status: NotificationStatus
}


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'BaseNotificationPanel'
},
  __name: 'BaseNotificationPanel',
  props: {
    status: {}
  },
  setup(__props: any) {





const iconName = computed(() => {
  if (__props.status === 'error') {
    return '$alert-circle-outline'
  }

  if (__props.status === 'warning') {
    return '$information-outline'
  }

  return '$check-circle-outline'
})

const iconClasses = computed(() => {
  if (__props.status === 'error') {
    return 'text-danger'
  }

  if (__props.status === 'warning') {
    return 'text-warning'
  }

  return 'text-success'
})

const containerClasses = computed(() => {
  if (__props.status === 'error') {
    return 'bg-danger-light border-danger'
  }

  if (__props.status === 'warning') {
    return 'bg-warning-light border-warning'
  }

  return 'bg-success-light border-success'
})

const iconProps = computed(() => ({
  class: [iconClasses.value],
  icon: iconName.value
}))

return (_ctx: any,_cache: any) => {
  const _component_VIcon = _resolveComponent("VIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex rounded-sm border border-l-4 py-6 pr-4", [containerClasses.value]])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_VIcon, _normalizeProps(_guardReactiveProps(iconProps.value)), null, 16)
    ]),
    _createElementVNode("div", null, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 2))
}
}

})